import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// style
import 'components/utils/typography/typography.css';

// components
import ScrollTop from 'components/utils/ScrollTop';
import Contact from 'components/contact/Contact';
import Header from 'components/header/Header';
import Footer from 'components/footer/Footer';
import ParticlesComponent from 'components/PartclesComponent';
import Routes from './routes';
import Popup from 'components/utils/Popup';

function App() {
  const [particlesKey, setParticlesKey] = useState(0);
  const location = useLocation();

  useEffect(() => {
    setParticlesKey((prevKey) => prevKey + 1);
  }, []);

  const normalizedPath = location.pathname.replace(/\/$/, '') || '/';
  const usesLegacyLayout =
    normalizedPath === '/feedback' ||
    /^\/(blog|portfolio|services)\/\d+$/.test(normalizedPath);

  if (!usesLegacyLayout) {
    return (
      <ScrollTop>
        <div className="fatality-redesign-app">
          <Routes />
        </div>
        <Popup />
      </ScrollTop>
    );
  }

  return (
    <ScrollTop>
      <div className="App pointer-none">
        <ParticlesComponent key={particlesKey} />
        <Header />
        <div className="container">
          <Routes />
        </div>
        <Contact />
        <Footer />
      </div>
      <Popup />
    </ScrollTop>
  );
}

export default App;
